module.exports = __webpack_public_path__ + "static/media/00.Akademy Performance Video.420e8ec1.mp4";